module.exports = __webpack_public_path__ + "static/media/no_poster.a9af4f3f.jpg";